import { gql } from '@apollo/client'

const EDIT_REJECT_REASON = gql`
  mutation EDIT_REJECT_REASON($rejectReason: ID!, $name: String!, $order: Int) {
    editRejectReason(rejectReason: $rejectReason, name: $name, order: $order) {
      id
      name
      order
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export default EDIT_REJECT_REASON
